export enum FeatureFlags {
    HasWearablesAccess = 'hasWearablesAccess'
}
